export function snakeCase(str: string = ''): string {
    return str
        .replace(/([^A-Z])([A-Z])/g, '$1_$2') // add _ character before every capital letter which previous character isn't capital letter
        .replace(/[\W_]+/g, '_') // replace non word characters and _ character with one _ character
        .replace(/^_+/, '') // trim _ characters at the start of string
        .replace(/_+$/, '') // trim _ characters at the end of string
        .toLowerCase(); // make whole string lowercase
}
